import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function QueryStatsIcon(props: IconProps) {
    return <Icon {...props} iconKey={"query_stats"}/>
}
